/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} HelloworldInputs */

const en_helloworld = /** @type {(inputs: HelloworldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hello world`)
};

/**
* | output |
* | --- |
* | "hello world" |
*
* @param {HelloworldInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const helloworld = /** @type {((inputs?: HelloworldInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HelloworldInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_helloworld(inputs)
});